module.exports = __webpack_public_path__ + "static/media/A13.d7a47f2a.png";